import React from "react";


import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import $ from "jquery";

import UserJpg from "../../../src/assests/images/user.jpg";
import './dashboardHeader.css';
import moment from "moment";
import { resetMiscData } from './../../redux/misc-data/misc-data.action';
import FinxPayLogo from "../../assests/images/finxpay.png";
import FinxPayIcon from "../../assests/images/logo.png";
import authReducer from './../../redux/auth/auth.reducer';
import { Link } from "react-router-dom";

class HeaderCommon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            message: ''
        }
    }



    componentDidMount() {

    }
    componentWillUnmount() {
    }



    goBackUrl = () => {
        window.location.href = this.props.callBackUrl;
    }


    render() {

        return (
            <div class="header">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-2 col-md-5 col-lg-6 col-xl-5">
                            <div class="logo">
                                <Link to="/dmt">
                                    <img src={'/images/' + this.props.logoName} alt="FinXpay" class="d-none d-sm-block" />

                                </Link>
                                <h3>{(window.location.href.toString().includes('bill') ||
                                    window.location.href.toString().includes('help') ||
                                    window.location.href.toString().includes('complaint-status')) ?
                                    'Bill Payment Service' :
                                    window.location.href.toString().includes('recharge') ?
                                        'Recharge' :
                                        window.location.href.toString().includes('aeps') ?
                                            'AePS' :
                                            'Domestic Money Transfer Services'}</h3>
                            </div>
                        </div>

                        <div class="col-10 col-md-7 col-lg-6 col-xl-7">
                            <div class="profile-box">

                                <button type="button" class="goback"
                                    onClick={this.goBackUrl}>Go back {this.props.partner}</button>

                                <div class="lstlog">Last Login: <span>{moment(this.props.agentInfo.lastLogin).format('DD-MM-YYYY hh:mm:ss')}</span></div>
                                <div class="usrnm">Hi, <span>{this.props.agentInfo.kioskName}</span> - <span>
                                    {this.props.agentInfo.id}</span>
                                    <br />

                                    {(window.location.href.toString().includes('bill') ||
                                        window.location.href.toString().includes('help') ||
                                        window.location.href.toString().includes('complaint-status')) ?
                                        <p> Contact:BillPay-8851470722 Chander Prakash<br />
                                            Email:emitra.support@finxpay.shop<br />
                                            Support time:9AM-6PM (Mon-Sat)</p> :
                                        window.location.href.toString().includes('recharge') ?
                                            <p> Contact:Recharge-8851470722 Chander Prakash<br />
                                                Email:emitra.support@finxpay.shop<br />
                                                Support time:9AM-6PM (Mon-Sat)</p> :
                                            window.location.href.toString().includes('aeps') ?
                                                '' :
                                                <p> Contact:DMT-8851470722 Chander Prakash<br />
                                                    Email:emitra.support@finxpay.shop<br />
                                                    Support time:9AM-6PM (Mon-Sat)</p>
                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner, logoName }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner, logoName, callBackUrl
});




export default connect(mapStateToProps, null)(HeaderCommon);
